import { useQuery } from 'react-query';
import { firestore } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';

const fetchGroups = async () => {
  const groupsRef = collection(firestore, "groups");
  const querySnapshot = await getDocs(groupsRef);
  return querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

export const useGroups = () => {
  return useQuery('groups', fetchGroups);
};
